export default "/images/no-image.svg?536160e968254afab72d27c9745b5740";